/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import 'firebase/analytics'
import 'firebase/functions'
import 'firebase/performance'
import PropTypes from 'prop-types'
import React from 'react'
import { FirebaseAnalytics } from './src/components/firebase-analytics/firebase-analytics'
import MessengerChat from './src/components/messenger-chat/messenger-chat'
import { AppProvider } from './src/data/app-context'

const activeEnv =
    process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'development'

export const wrapRootElement = ({ element }) => (
    <AppProvider>
        <React.Fragment>
            <FirebaseAnalytics />
            {element}
        </React.Fragment>
    </AppProvider>
)

wrapRootElement.propTypes = {
    element: PropTypes.node.isRequired
}

export const wrapPageElement = ({ element, props }) => (
    <React.Fragment>
        {element}
        {activeEnv !== 'development' && <MessengerChat />}
    </React.Fragment>
)

wrapPageElement.propTypes = {
    element: PropTypes.node.isRequired,
    props: PropTypes.object
}
